<div class="container mt-5">

    <foehn-page-counter></foehn-page-counter>

    <foehn-form>
        <div class="row">
            <div class="col-md-8">

                <foehn-boolean-checkbox
                    (userInput)="legalRepresentativeRequestInitiatorChange($event)"
                    [(model)]="form.legalRepresentative.isLegalRepresentativeRequestInitiator"
                    [label]="'legal-representative.isLegalRepresentativeRequestInitiator.label' | fromDictionary"
                    [required]="false"
                    name="legalRepresentative.isLegalRepresentativeRequestInitiator"
                >
                </foehn-boolean-checkbox>

                <foehn-select
                    [(model)]="form.legalRepresentative.relation"
                    [elementValue]="wholeValue"
                    [elements]="relations"
                    [label]="'legal-representative.relation.label' | fromDictionary"
                    elementLabel="valeur"
                    name="legalRepresentative.relation"
                    required="true"
                >
                </foehn-select>

                <foehn-input-text
                    [(model)]="form.legalRepresentative.lastName"
                    [disabled]="form.legalRepresentative.isLegalRepresentativeRequestInitiator"
                    [label]="'legal-representative.lastName.label' | fromDictionary"
                    name="legalRepresentative.lastName"
                    required="true"
                >
                </foehn-input-text>

                <foehn-input-text
                    [(model)]="form.legalRepresentative.firstName"
                    [disabled]="form.legalRepresentative.isLegalRepresentativeRequestInitiator"
                    [label]="'legal-representative.firstName.label' | fromDictionary"
                    name="legalRepresentative.firstName"
                    required="true"
                >
                </foehn-input-text>

                <foehn-input-address
                    [(model)]="form.legalRepresentative.address"
                    [label]="'legal-representative.address.label' | fromDictionary"
                    [required]="false"
                    [showAdressLines]="false"
                    [streetNumberRequired]="false"
                    [streetRequired]="false"
                    [swissNpaLocalityRequired]="false"
                    name="legalRepresentative.address"
                ></foehn-input-address>

                <foehn-input-text
                    [(model)]="form.legalRepresentative.additionalAddress"
                    [label]="'information-applicant.additionalAddress.label' | fromDictionary"
                    name="legalRepresentative.additionalAddress"
                ></foehn-input-text>

                <foehn-input-phone
                    [(model)]="form.legalRepresentative.phone"
                    [label]="'legal-representative.phone.label' | fromDictionary"
                    name="legalRepresentative.phone"
                ></foehn-input-phone>

                <foehn-input-email
                    [(model)]="form.legalRepresentative.email"
                    [disabled]="form.legalRepresentative.isLegalRepresentativeRequestInitiator"
                    [label]="'legal-representative.email.label' | fromDictionary"
                    name="legalRepresentative.email"
                >
                </foehn-input-email>

                <foehn-navigation
                    (onNext)="send()"
                    (onPrevious)="previous()"
                    id="navigation"
                ></foehn-navigation>
            </div>
        </div>
    </foehn-form>
</div>
